<template>
    <div class="wrapperOverflowHide">
        <vue-loader-component :active="loader.status" :message="loader.message"></vue-loader-component>
        <TransitionGroup name="slide-right" >
            <div class="card card-custom gutter-b" v-for="work, index in worksList" :key="work.id" :index="index" v-if="!works">
                <div class="card-body">
                    <div class="card card-custom">
                        <div class="card-header border-0">
                            <div class="card-title">
                                <span class="card-icon"><i class="fas fa-sitemap text-primary"></i></span>
                                <h3 class="card-label">Нет работ для подтверждения</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-custom gutter-b" v-for="work, index in worksList" :key="work.id" :index="index" v-if="works">
                <div class="card-body">
                    <div class="card card-custom">
                        <div class="card-header border-0">
                            <div class="card-title">
                                <span class="card-icon"><i class="fas fa-sitemap" :class="'text-' + (work.statusObj?.color??'primary')"></i></span>
                                <h3 class="card-label">
                                    Заказ #{{ work.order?.number??'---' }} [id:{{ work.order?.id??'-' }}] 
                                    <span class='ml-3 label label-inline label-primary font-weight-bolder' v-if="work.order.name">{{ work.order.name }}</span>
                                    <span class="d-block text-muted pt-2 font-size-sm" v-if="work.order.remark">{{ work.order.remark }}</span>
                                </h3>
                            </div>
                            <div class="card-toolbar">
                                <div class="btn btn-danger" @click="getModalSuccess(index)">Подтвердить</div>
                            </div>
                        </div>
                        <div class="separator separator-solid separator-white opacity-20"></div>
                        <div class="card-body">
                            <div class="blockOrderWorkProcessing">
                                <div class="itemOrderWorkProcessing">
                                    <div class="labelItem">Передающий <span :class="'ml-3 label label-inline label-' + (work.additional_of_work?.statusObj?.color??'primary') + ' font-weight-bolder'">{{ work.additional_of_work?.statusObj?.label??'не известно' }}</span></div>
                                    <div class="blockItem">
                                        <div class="name">Работа</div>
                                        <div class="text">{{ work.additional_of_work?.production_work?.label??'---' }} [id:{{ work.additional_of_work?.id??'---' }}]</div>
                                    </div>
                                    <div class="blockItem">
                                        <div class="name">Ответственный</div>
                                        <div class="text">{{ work.additional_of_work?.responsible_user?.name??'---' }} {{ work.additional_of_work?.responsible_user?.phone??'---' }}</div>
                                    </div>
                                    <div class="blockItem">
                                        <div class="name">Участок</div>
                                        <div class="text">{{ work.additional_of_work?.workshop?.label??'---' }}</div>
                                    </div>
                                </div>
                                <div class="itemOrderWorkProcessing">
                                    <div class="labelItem">Получающий <span :class="'ml-3 label label-inline label-' + (work.statusObj?.color??'primary') + ' font-weight-bolder'">{{ work.statusObj?.label??'не известно' }}</span></div>
                                    <div class="blockItem">
                                        <div class="name">Работа</div>
                                        <div class="text">{{ work.production_work?.label??'---' }} [id:{{ work.id??'---' }}]</div>
                                    </div>
                                    <div class="blockItem">
                                        <div class="name">Ответственный</div>
                                        <div class="text">{{ work.responsible_user?.name??'---' }} {{ work.responsible_user?.phone??'---' }}</div>
                                    </div>
                                    <div class="blockItem">
                                        <div class="name">Участок</div>
                                        <div class="text">{{ work.workshop?.label??'---' }}, {{ work.department?.label??'---' }}, {{ work.direction?.label??'---' }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="blockComment" v-if="work.comments && work.comments.length > 0">
                                <div class="labelItem text-primary">Комментарии:</div>
                                <div class="itemComment" v-for="comment in work.comments">{{ comment.comment }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TransitionGroup>
    </div>

    <Transition name="bounce-child">
    <div class="modalSuccessWorkAction modalCrg" v-if="modalSuccessAccess.status">
        <div class="modal-content">
            <div class="btn-close" @click="abortSuccessAction()">X</div>
            <div class="modal-body">
                <!-- <div class="type">
                    <i class="fas fa-exclamation text-warning"></i>
                </div> -->
                <div class="modal-label">{{ modalSuccessAccess.label }}</div>
                <div class="modal-text" v-if="modalSuccessAccess.text" v-html="modalSuccessAccess.text"></div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label>Время работы, мин</label>
                            <input v-model="modalSuccessAccess.deadlines_minutes" class="form-control form-control-solid numberInputInt">
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label>Стоимость работы, руб</label>
                            <input v-model="modalSuccessAccess.price" class="form-control form-control-solid numberInputInt">
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <textarea v-model="modalSuccessAccess.comment" class="form-control form-control-solid" placeholder="Комментарий" rows="3"></textarea>
                        </div>
                    </div>
                </div>
                <div class="modal-btns">
                    <button class="btn btn-danger" @click="setSuccessAction()">Подтвердить</button>
                    <button class="btn btn-primary" @click="abortSuccessAction()">Отмена</button>
                </div>
            </div>
        </div>
    </div>
    </Transition>

    <textarea style="width: 100%; min-height: 280px">{{ works }}</textarea>
    <!-- <textarea style="width: 100%; min-height: 80px">{{ employeeOptions }}</textarea> -->
    <!-- <textarea style="width: 100%; min-height: 80px">{{ employeeOptionsList }}</textarea> -->
</template>

<script>
// import VueSelectHtml from '@/Components/VueSelectHtml.vue';

export default {
    // components: { VueSelectHtml },
    // props: {
    //     employeeId: {type: Number, default: ''},
    //     employees: {type: Object, default: null}
    // },
    data() {
        return {
            token: null,
            works: null,
            loader: {
                status: false,
                message: null,
            },
            modalSuccessAccess: {
                status: false,
                label: null,
                text: null,
                workIndex: null,
                workId: null,
                deadlines_minutes: null,
                price: null,
                comment: null,
            },

            timing: null,
        }
    },
    mounted(){
        this.token = document.querySelector("[name=csrf-token]").content;
        this.getAdditionalWorks();
        this.timing = setInterval(()=>{ this.updateAdditionalWorks() }, 10000)
    },
    computed: {
        worksList: function(){
            return this.works
                ? this.works.sort((a, b) => { return a.id - b.id;})
                : [];
        },
    },
    methods: {
        getModalSuccess(index){
            let work = this.works[index];
            this.modalSuccessAccess.label = 'Подтверждение работы';
            this.modalSuccessAccess.text = '<div>Заказ ' + work.order.number + '</div>';
            this.modalSuccessAccess.text += '<div>Работа ' + (work.production_work?.label??'---') + '</div>';
            this.modalSuccessAccess.workIndex = index;
            this.modalSuccessAccess.workId = work.id;
            this.modalSuccessAccess.deadlines_minutes = work.deadlines_minutes;
            this.modalSuccessAccess.price = work.price;
            this.modalSuccessAccess.status = true;
        },
        clearModalInputs(){
            this.modalSuccessAccess.label = null;
            this.modalSuccessAccess.text = null;
            this.modalSuccessAccess.workIndex = null;
            this.modalSuccessAccess.workId = null;
            this.modalSuccessAccess.deadlines_minutes = null;
            this.modalSuccessAccess.price = null;
            this.modalSuccessAccess.comment = null;
        },
        abortSuccessAction(){
            this.clearModalInputs();
            this.modalSuccessAccess.status = false;
        },

        setSuccessAction(){
            let _this = this;
            try {
                let workIndex = this.modalSuccessAccess.workIndex;
                let idWork = this.modalSuccessAccess.workId;
                let deadlines_minutes = this.modalSuccessAccess.deadlines_minutes;
                let price = this.modalSuccessAccess.price;
                let comment = this.modalSuccessAccess.comment;
                if(parseFloat(deadlines_minutes) <= 0 || deadlines_minutes.length <= 0){ throw new Error("Не верно заполнено поле Время выполнения"); }
                if(parseFloat(price) <= 0 || price.length <= 0){ throw new Error("Не верно заполнено поле Цена"); }
                let postData = {
                    deadlines_minutes: parseFloat(deadlines_minutes), 
                    price: parseFloat(price), 
                    comment: comment
                };
                this.loader.status = true; this.loader.message = 'Записываем подтверждение';
                axios.post('/web-api/order-works/' + idWork + '/set-success-additional-working', 
                    postData, 
                    { headers: { 'Content-Type': 'application/json' }}
                )
                .then(function(res){
                    console.log('web-api/order-works/set-success-additional-working');
                    console.log(res.data);
                    if(res.data.status == true){
                        _this.works.splice(workIndex, 1);
                        window.getAlert('success', 'Отлично', res.data.message);
                        _this.abortSuccessAction();
                    } else {
                        window.getAlert('error', 'Ошибка', res.data.message)
                    }
                })
                .catch(function(error){
                    console.log(error);
                    _this.loader.status = false; _this.loader.message = null;
                    window.$func.exceptionsHandler(error);
                })
                .then(() => {
                    // this.abortSuccessAction();
                    _this.loader.status = false; _this.loader.message = null;
                });
            } catch (error) {
                console.log(error);
                // window.$func.getAlert('error', 'Ошибка', error)
                window.getAlert('error', 'Ошибка', error.message)
            }
        },

        async loadAdditionalWorks(){
            let _this = this;
            let result = null;
            console.log('load works');
            await axios.post('/web-api/order-works/get-additional-works', 
                { headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.token
                }}
            )
            .then(function(res){
                console.log(res.data);
                if(res.data.status == true){
                    _this.works = res.data.data.works;
                } else {
                    // result = res.data;
                    window.getAlert('error', 'Ошибка', res.data.message)
                }
            })
            .catch(function(error){
                console.log(error);
                window.$func.exceptionsHandler(error);
            });
            _this.loader.status = false; _this.loader.message = null;
            return result;
        },

        async getAdditionalWorks(){
            let _this = this;
            this.loader.status = true; this.loader.message = 'Загружаем работы';
            // await axios.post('/web-api/order-works/get-additional-works', 
            //     { headers: {
            //         'Content-Type': 'application/json',
            //         'X-CSRF-TOKEN': this.token
            //     }}
            // )
            // .then(function(res){
            //     console.log(res.data);
            //     if(res.data.status == true){
            //         _this.works = res.data.data.works;
            //     } else {
            //         window.getAlert('error', 'Ошибка', res.data.message)
            //     }
            // })
            // .catch(function(error){
            //     console.log(error);
            //     window.$func.exceptionsHandler(error);
            // })
            // .then(() => {
            //     _this.loader.status = false; _this.loader.message = null;
            // });
            await this.loadAdditionalWorks().then(() => {
                // console.log(result);
                // if(result != null && typeof result.status != "undefined" && result.status == false){
                //     window.getAlert('error', 'Ошибка', res.data.message)
                // }
                _this.loader.status = false; _this.loader.message = null;
            });
        },
        async updateAdditionalWorks(){
            let _this = this;
            await this.loadAdditionalWorks().then(() => {
                _this.loader.status = false; _this.loader.message = null;
            });
        },

    },
    beforeDestroy() {
        clearInterval(this.timing);
    }
}
</script>